export enum PAGES {
    MAIN = 1,
    PARTICIPATION = 2,
    PARTICIPANTS = 3,
    PARTNERS = 4,
    VISITORS = 5,
    EXPO = 7,
    TECHNOLOGICAL = 8,
    HR = 9,
    PREMIYA_TEC = 23,
    PROGRAM = 10,
    NEW_PROGRAM = 24,
    REGISTRATION = 14,
    HOTELS = 16,
    SERVICES = 13,
    SHUTTLES = 19,
    CAR_RENTAL = 17,
    CAR_ACCREDITATION = 18,
    FOOD_AREAS = 20,
    KONTAKTY = 15,
    PAVILION = 2,
    TEAM = 25,
}

export const COMMUNITY_EVENTS_LIMIT = 4;

export const MAIN_FORUM_EDITION_YEAR = 2026;

export const MONTH_DICT = {
    1: 'января',
    2: 'февраля',
    3: 'марта',
    4: 'апреля',
    5: 'мая',
    6: 'июня',
    7: 'июля',
    8: 'августа',
    9: 'сентября',
    10: 'октября',
    11: 'ноября',
    12: 'декабря',
} as const;

export const MONTH_NAME_TO_NUM: Record<string, number> = Object.fromEntries(
    Object.entries(MONTH_DICT).map(([num, name]) => [name, Number(num)]),
);

export const DAYS_SHORTNAMES_DICT = {
    0: 'Вс',
    1: 'Пн',
    2: 'Вт',
    3: 'Ср',
    4: 'Чт',
    5: 'Пт',
    6: 'Сб',
} as const;

export const SEARCH_RESULT_PAGE_LIMIT = 20;

export const STORAGE_SCROLL_POSITION = 'scrollPosition';
